<template>
  <div class="section-body_title">
    <i
      class="el-icon-setting"
      style="margin-right: 7px; font-size: 22px"
    />
    <span>{{ cnName }}</span>
    <el-tooltip
      v-if="tooltip"
      class="item tooltip"
      effect="dark"
      :content="tooltip"
      placement="top-start"
    >
      <i
        class="el-icon-question"
        style="margin-left: 5px"
      />
    </el-tooltip>
  </div>
</template>
<script>
export default {
  name: 'FormSectionTitle',
  props: {
    cnName: {
      type: String,
      default: '',
    },
    tooltip: {
      default: '',
      type: String
    },
    desc: {
      default: '',
      type: String
}
  },
  data () {
    return {}
  },
  watch: {},
  created () {},
  methods: {}
}
</script>

<style scoped lang="scss">
.section-body_title {
  height: 40px;
  width: 100%;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  line-height: 40px;
  margin-bottom: 28px;
  border-bottom: 1px solid #e9e9e9;
  i {
    font-size: 12px;
  }
  .tooltip {
    cursor: pointer;
  }
}
</style>
